import script from "./MyEventsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MyEventsHeader.vue?vue&type=script&setup=true&lang=js"

import "./MyEventsHeader.vue?vue&type=style&index=0&id=67037804&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67037804"]])

export default __exports__